import { render, staticRenderFns } from "./AddExternalAcademic.vue?vue&type=template&id=331353cc"
import script from "./AddExternalAcademic.vue?vue&type=script&lang=js"
export * from "./AddExternalAcademic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports